export default __webpack_public_path__ + "static/media/drill_rig.c02defb7.jpg";